<template>
    <div class="d-none">
        <div :id="modal_id" class="modal-box">
            <div class="close-button"> <a href="javascript:;" class="modal-close white"></a> </div>
            <div class="modal-container bg-light-grey txt-grey2 padding0">
                <div class="modal-calendar row g-0 p-5 mb-5">
                    <div class="featured col-12 col-md-4 p-3">
<!--                        <span v-if="this.offer && this.offer.MerchantImageURL" class="img-name" :style="{ backgroundImage: 'url(' + image + ')' }"></span>-->
                        <span class="img-name" :style="{ backgroundImage: 'url(' + image + ')' }"></span>
                    </div>
                    <div class="data col-12 col-md-8 ps-5">
                        <h2 class="fs-1 mb-4 bold">{{this.offer.Headline}}</h2>
                        <p class="fs-2  mb-4 text-uppercase">Benefits Calendar</p>
                        <div v-if="this.offer && this.offer.Benefits && this.offer.Benefits.length" class="days-buttons mb-5">
                            <span   v-for="(item, index) in this.offer.Benefits.slice(0, 7)" :class="item.Value == 0 ? 'btn-circle shadow p-3': 'btn-circle active shadow p-3'">{{item.DayOfWeek.slice(0,2)}}</span>
                        </div>
                        <div v-if="this.offer.ActiveSc == 'AVAILABLE' && !this.activatedNow">
<!--                            <a @click="showEnrollCard" class="button pink tinysize small mTop10 modal-link">Activate</a>-->
                            <a @click="activateOrShowEnrollCard"  :disabled="activating" :class="(activating || show_offer_activation_failed_msg) ? 'button pink tinysize small mTop10 modal-link isDisabled' : 'button pink tinysize small mTop10 modal-link'">{{this.activating ? 'Activating' : 'Activate' }}</a>
                            <p class="offerActivationFailedMsg" style="font-size: 1vw" v-if="show_offer_activation_failed_msg">Offer Activation Failed</p>
                        </div>
                        <div v-if="this.offer.ActiveSc != 'AVAILABLE' || this.activatedNow">
                            <a href="javascript:" class="button pink activated tinysize small mTop10 modal-link">Activated</a>
                        </div>
                    </div>
                </div>
                <div class="row g-0 px-5 mb-5">
                    <div class="col-12 col-md-5">
                        <map-component
                            :offerLocations="offer_locations"
                            :mapId = "offer_detail_map_id"
                            :mapCenter = "map_center"
                            :zoomSetting="8"
                            :dontShowInfoWindow="true"
                            :dontShowText="true"
                        ></map-component>

                    </div>
                    <div class="col-12 col-md-7 ps-5 txt-grey2">
                        <h2 class="fs-2 mb-3">About</h2>
                        <p v-if="!readMoreActivated" class="fs-3 mb-4">{{this.offer && this.offer.ShortDescription ? this.offer.ShortDescription.slice(0,200) : ''}}

                            <a  style="color:#F26B1C" v-if="(!readMoreActivated && this.offer && this.offer.ShortDescription && this.offer.ShortDescription.length > 200)" @click="activateReadMore" href="javascript:;">
                                read more...
                            </a>
                        </p>

                        <p v-if="readMoreActivated" class="fs-3 mb-4">{{this.offer && this.offer.ShortDescription ? this.offer.ShortDescription : ''}}</p>
<!--                        <p class="fs-3">Phone - 555.555.5555</p>-->
                        <p class="fs-3">Website - <a :href="(this.offer && this.offer.Merchant && this.offer.Merchant.WebsiteUrl) ? this.offer.Merchant.WebsiteUrl : '#'" target="_blank" class="txt-grey2">{{(this.offer && this.offer.Merchant && this.offer.Merchant.WebsiteUrl) ? this.offer.Merchant.WebsiteUrl : ''}}</a> </p>
                        <p class="fs-3">{{this.address}}</p>
                    </div>
                </div>
                <div class="modal-info">
                    <h5 class="heading__h5 text-center">Offer Details</h5>

                    <p v-if="!readMoreDetailsActivated" class="fs-3 mb-4">{{this.offer && this.offer.LongTerms ? this.offer.LongTerms.slice(0,300) : ''}}

                        <a style="color:#F26B1C" v-if="(!readMoreDetailsActivated && this.offer && this.offer.LongTerms && this.offer.LongTerms.length > 300)" @click="activateDetailsReadMore" href="javascript:;">
                            read more...
                        </a>
                    </p>

                    <p v-if="readMoreDetailsActivated">{{this.offer && this.offer.LongTerms ? this.offer.LongTerms : ''}}</p>

<!--                    <div class="button-container text-center">-->
<!--                        <a href="javascript:;" class="button fs-4 txt-black">View full terms &amp; conditions</a>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  components: {  },
    name: 'OfferCalendarDetailsComponent',
    props: ['offer', 'activatedNow', 'show_offer_activation_failed_msg'],
    data(){
        return {
            modal_id: (this.offer && this.offer.OfferId) ? 'offer-calendar-modal-'+this.offer.OfferId : 'offer-calendar-modal-'+_.random(1, 10000000) + _.random(1, 10000000),
            offer_detail_map_id: (this.offer && this.offer.OfferId) ? 'offer_detail_map_id_'+this.offer.OfferId : 'offer_detail_map_id_'+_.random(1, 10000000) + _.random(1, 10000000),
            offer_locations : this.setMerchantInfo('offer_location'),
            address : this.setMerchantInfo('address'),
            map_center : this.setMerchantInfo('map_center'),
            hours: this.offer && this.offer.hours ? this.offer.hours : [],
            readMoreActivated: false,
            readMoreDetailsActivated: false,
            activating: false,
            image: this.offer && this.offer.hasOwnProperty('MerchantImageURL') ? this.offer.MerchantImageURL : '../images/placeholder.jpg',
        }
    },
    methods : {
        reload(user) {
            this.$emit('reload', user)
        },

        reloadOffer(offer) {
            this.$emit('reloadOffer', offer)
        },
        activateReadMore(){
            this.readMoreActivated = true;
        },
        activateDetailsReadMore(){
            this.readMoreDetailsActivated = true;
        },

        activateOrShowEnrollCard() {
             this.activating = true;
            this.$emit('showEnrollCardOrActivate');
        },
        setMerchantInfo(info) {

           let ret = null;

            if(this.offer ?. Merchant ?. Addresses ?. Address) {

                let innerObj = this.offer.Merchant.Addresses.Address[0];

                switch (info) {

                    case 'map_center':
                        ret = {};
                        if(innerObj.Latitude && innerObj.Longitude) {
                            ret = {
                                longitude:innerObj.Longitude,
                                latitude:innerObj.Latitude,
                            };
                        }
                        break;

                    case 'address':
                            ret = '';
                            if(innerObj.Street) {
                                ret = innerObj.Street;
                            }
                            break;

                    case "offer_location":
                                ret = [];
                                innerObj['MerchantName'] = this.offer.Merchant.Name;
                                ret = [innerObj];

                                break;

                    default:
                        break;
                }
            }

            return ret;
        }
    },

    watch: {
        activatedNow: function (val) {
            this.activating = false;
        },
        show_offer_activation_failed_msg: function (val) {
            if(val) {
                this.activating = false;
            }
        }
    },
    updated() {
    },
    mounted: function() {
        $('.modal-close').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });
  }
}
</script>

<style scoped>
    .isDisabled {
        pointer-events: none;
    }
    .offerActivationFailedMsg{
        color: #eb2d2e;
        font-size: 1vw;
        padding: 0.5vw 0.5vw 0.5vw 0;
    }
    </style>
